import type {Principal} from '@afroep/core/auth/principal';
import type {UpdateProfile, User} from '@afroep/core/domain/user';
import {ROUTES} from '@afroep/core/http/routes';
import {call} from '@/lib/api-client';

export const fetchMe = (): Promise<Principal> => call(ROUTES.getMe);

export const updateMe = (patch: UpdateProfile): Promise<User> => call(ROUTES.updateMe, {body: patch});
